import useSWR from 'swr'

import {
  DEFAULT_COUNTRY,
  sharedStaticConfig,
} from '@ngb-frontend/shared/config'
import {
  groupMalfunctionCodes,
  filterMalfunctionCodes,
} from '@ngb-frontend/shared/utils'

import type {
  CountrySetting,
  CountryConfig,
  AdditionalServiceValue,
  EnabledServices,
} from '@ngb-frontend/shared/types'

export const useBusinessRules = (
  countryCode = DEFAULT_COUNTRY,
  isAyvens?: boolean,
) => {
  return useSWR<CountrySetting[]>(
    isAyvens && countryCode
      ? [sharedStaticConfig.apiRoutes.countrySettings, { countryCode }]
      : null,
  )
}

export const countrySettingToConfig = (
  settings: CountrySetting,
): Omit<
  CountryConfig,
  'countryCode' | 'autopickPNRSupplier' | 'isAyvens' | 'is'
> => {
  const supportedMalfunctions = filterMalfunctionCodes(
    settings.EnabledMalfunctions__c?.split(';') || [],
  )
  const malfunctions = groupMalfunctionCodes(supportedMalfunctions)
  // TODO: implement dynamic type checking of the additional services
  const enabledAdditionalServices =
    (settings.EnabledAdditionalServices__c?.split(';') || []) as (
      | AdditionalServiceValue
      | 'MOT'
      | 'Mot'
    )[] // MOT is an exceptional case of a main service that can be controlled via SF as an "additional service"

  const enabledServices: EnabledServices = {
    ReplacementVehicle:
      enabledAdditionalServices.includes('ReplacementVehicle'),
    PickupAndReturn: enabledAdditionalServices.includes('PickupAndReturn'),
    ComplementaryCleaning: enabledAdditionalServices.includes(
      'ComplementaryCleaning',
    ),
    MOT:
      enabledAdditionalServices.includes('MOT') ||
      // TODO: Remove after BE fix
      enabledAdditionalServices.includes('Mot'),
  }

  return {
    detailedRPV: settings.EnableDetailedReplacementVehicle__c,
    additionalServices: enabledServices,
    malfunctions: malfunctions || {},
    minBookingDaysDriver: settings.DriverMinimumDaysBooking__c,
    minBookingDaysAgent: settings.AgentMinimumDaysBooking__c,
  }
}
